import { render, staticRenderFns } from "./ColorsMainPalleteSection.vue?vue&type=template&id=520d6d11"
import script from "./ColorsMainPalleteSection.vue?vue&type=script&lang=ts"
export * from "./ColorsMainPalleteSection.vue?vue&type=script&lang=ts"
import style0 from "./ColorsMainPalleteSection.vue?vue&type=style&index=0&id=520d6d11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports